import { TemporaryMessage } from './TemporaryMessage'
export default TemporaryMessage
